import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ScreenContainer from "../../Components/ScreenContainer";
import { usePermissions } from "../../Context/PermissionContext";
import RolesPermissionsTab from "../../PagesContent/AccessManagement/RolesPermissions/RolesPermissionsTab";
import UserAssignmentsTab from "../../PagesContent/AccessManagement/UserAssignments/UserAssignmentsTab";

const AccessManagement = () => {
  const [pagesContent] = useState({ mounted: true });
  const { isRbacV2Enabled } = usePermissions();
  const { pathname } = useLocation();

  if (!isRbacV2Enabled()) {
    return (
      <ScreenContainer pagesContent={pagesContent}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100vh - 50px)",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            Feature Not Available
          </Typography>
        </Box>
      </ScreenContainer>
    );
  }

  const isUsers = pathname.includes("/users");
  const pageTitle = isUsers ? "Manage Users" : "Roles & Permissions";

  return (
    <ScreenContainer pagesContent={pagesContent}>
      <Box
        sx={{
          position: "sticky",
          top: "50px",
          zIndex: 1000,
          backgroundColor: "#FAFAFA",
        }}
      >
        <Box sx={{ px: 3, pt: 2, pb: 2 }}>
          <Typography variant="fw700s20lh24c2E2E2E">{pageTitle}</Typography>
        </Box>
      </Box>
      <Box sx={{ px: 3, pb: 3 }}>
        {isUsers ? <UserAssignmentsTab /> : <RolesPermissionsTab />}
      </Box>
    </ScreenContainer>
  );
};

export default AccessManagement;
